import React from 'react';
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { MediaModuleImageCard } from "./media-module-card";
import {
  MediaModuleImageVariant,
  IMediaModuleImageProps
} from "./media-module.types";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";

const MediaModuleImage = (props: IMediaModuleImageProps) => {
  try {
    const { id, aboveTheFold, mediaCard, cardHeight, isInpageWidth } = props;
    const variant =
      mediaCard?.length > 1 ?
        MediaModuleImageVariant.TWO_UP :
        MediaModuleImageVariant.ONE_UP;
    return (
      <DtvBox
        id={id}
        sx={{
          width: isInpageWidth ? "auto" : "100%",
          display: "flex",
          gap: "20px",
          flexWrap: {
 md: "nowrap",
xs: "wrap"
},
          flexDirection: "row",
          margin: isInpageWidth ? {
 xs: "auto 20px",
sm: "auto 32px",
md: "auto 100px",
lg: "auto 140px",
xl: "auto 180px"
} : "0px"
        }}
      >
        {mediaCard?.map(card => (
          <MediaModuleImageCard
            aboveTheFold={aboveTheFold}
            key={card.id}
            {...card}
            cardHeight={cardHeight}
            variant={variant}
          />
        ))}
      </DtvBox>
    );
  } catch (error) {
    return (
      <ErrorDisplay
        component="Media Card Image Container 1-up 2-up V2 "
        error={error}
      />
    );
  }
};

export default MediaModuleImage;
